var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAlvotechAward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#222222;}\n\t.st1{fill:#F69D25;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#F69D25;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#222222;}\n\t.st4{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pipline"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "biosimilar"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "employees"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "network"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "generic-projects"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "manufacturing-centers"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "key-growth"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "molecule"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "green"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "map"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "playground"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "microscope"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "basket"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "hand-pill"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "cosmetics"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "medical"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "dna_1_"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "investment"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "company"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "square-meter"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "bios-generics"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "professional"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "manufacturing"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "capacity"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "award"
  }, /*#__PURE__*/React.createElement("g", {
    id: "neutral_25_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M413.6,182.7c-9.1-6.4-13-20.9-8.3-31.1c4.9-10.6,4.8-21.8-0.3-30.6c-5.1-8.9-14.7-14.5-26.3-15.6 c-11.1-1-21.7-11.6-22.8-22.8c-2.1-23.4-24.6-36.6-46.2-26.6c-10,4.5-24.9,0.5-31.1-8.3c-13.4-19.1-39.9-19.1-53.3,0 c-6.2,8.8-21.2,12.9-31.1,8.3c-21.6-10-44.1,3.3-46.2,26.6c-1,11.1-11.6,21.8-22.8,22.8c-11.6,1.1-21.2,6.7-26.3,15.6 c-5.1,8.8-5.2,20-0.3,30.6c4.7,10.1,0.8,24.6-8.3,31.1c-9.5,6.7-15,16.4-15,26.7s5.5,19.9,15,26.7c9.1,6.4,13,20.9,8.3,31.1 c-4.9,10.6-4.8,21.8,0.3,30.6c5.1,8.9,14.7,14.5,26.3,15.6c9.7,0.9,18.6,9.1,21.5,18.5L97.7,479.1l64.2-32.1l51.6,25.8l29.4-88.3 c2.9,1,5.9,1.6,9,1.6c3.1,0,6.1-0.6,9-1.6l29.4,88.3l51.6-25.8l64.2,32.1l-49.1-147.2c2.9-9.4,11.8-17.7,21.5-18.5 c11.6-1.1,21.2-6.7,26.3-15.6c5.1-8.8,5.2-20,0.3-30.6c-4.7-10.1-0.8-24.6,8.3-31.1c9.5-6.7,15-16.4,15-26.7 S423.1,189.5,413.6,182.7z M223.9,370.2L200.3,441l-38.4-19.2l-25.7,12.9l24.9-74.8c8.9,6.6,21.1,8.4,33.1,2.8 c9.7-4.5,24.2-0.6,30.6,7.9C224.5,370.5,224.2,370.4,223.9,370.2z M367.6,434.7l-25.7-12.9L303.5,441l-23.6-70.8 c-0.3,0.2-0.5,0.2-0.8,0.4c6.4-8.5,20.8-12.4,30.6-7.9c12,5.6,24.2,3.8,33.1-2.8L367.6,434.7z M400.6,217.7 c-18.2,12.8-25.1,38.7-15.8,58.9c1.8,3.9,2,7.4,0.6,9.9c-1.4,2.5-4.6,4-8.9,4.4c-22.2,2-41.1,21-43.1,43.1 c-0.3,3.6-1.8,9.8-8.2,9.8c-1.9,0-3.9-0.5-6.1-1.5c-19.6-9.1-46.6-1.8-58.9,15.8c-5,7-11.6,7.1-16.5,0 c-8.7-12.3-23.9-19.9-39.8-19.9c-6.8,0-13.2,1.4-19.1,4.1c-2.2,1-4.3,1.5-6.1,1.5c-6.4,0-7.9-6.1-8.2-9.8 c-2-22.2-21-41.1-43.1-43.1c-4.3-0.4-7.4-2-8.9-4.4c-1.4-2.5-1.2-6,0.6-9.9c9.4-20.2,2.4-46.1-15.8-58.9c-3.5-2.5-5.5-5.4-5.5-8.3 c0-2.9,2-5.8,5.5-8.3c18.2-12.8,25.1-38.7,15.8-58.9c-1.8-3.9-2-7.4-0.6-9.9c1.4-2.5,4.6-4,8.9-4.4c22.2-2,41.1-21,43.1-43.1 c0.3-3.6,1.8-9.8,8.2-9.8c1.9,0,3.9,0.5,6.1,1.5c5.9,2.7,12.3,4.1,19.1,4.1c0,0,0,0,0,0c15.9,0,31.1-7.6,39.8-19.9 c5-7,11.6-7.1,16.5,0c12.3,17.5,39.3,24.8,58.9,15.8c2.2-1,4.3-1.5,6.1-1.5c6.4,0,7.9,6.1,8.2,9.8c2,22.2,21,41.1,43.1,43.1 c4.3,0.4,7.4,2,8.9,4.4c1.4,2.5,1.2,6-0.6,9.9c-9.4,20.2-2.4,46.1,15.8,58.9c3.5,2.5,5.5,5.4,5.5,8.3 C406.1,212.3,404.1,215.2,400.6,217.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M251.9,85.7c-68.2,0-123.7,55.5-123.7,123.7s55.5,123.7,123.7,123.7c68.2,0,123.7-55.5,123.7-123.7 S320.1,85.7,251.9,85.7z M251.9,310.7c-55.8,0-101.2-45.4-101.2-101.2s45.4-101.2,101.2-101.2c55.8,0,101.2,45.4,101.2,101.2 S307.7,310.7,251.9,310.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "color_19_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M206.9,175.7h90c6.2,0,11.2-5,11.2-11.2c0-6.2-5-11.2-11.2-11.2h-90c-6.2,0-11.2,5-11.2,11.2 C195.7,170.6,200.7,175.7,206.9,175.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M184.4,198.2c-6.2,0-11.2,5-11.2,11.2c0,6.2,5,11.2,11.2,11.2h135c6.2,0,11.2-5,11.2-11.2 c0-6.2-5-11.2-11.2-11.2H184.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M274.4,243.2h-45c-6.2,0-11.2,5-11.2,11.2c0,6.2,5,11.2,11.2,11.2h45c6.2,0,11.2-5,11.2-11.2 C285.6,248.2,280.6,243.2,274.4,243.2z"
  })))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "pills"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "people"
  })));
}

export default SvgAlvotechAward;